import { render, staticRenderFns } from "./subjectsNew.vue?vue&type=template&id=1298a095&scoped=true&"
import script from "./subjectsNew.vue?vue&type=script&lang=js&"
export * from "./subjectsNew.vue?vue&type=script&lang=js&"
import style0 from "./subjectsNew.vue?vue&type=style&index=0&id=1298a095&lang=scss&scoped=true&"
import style1 from "./subjectsNew.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./subjectsNew.vue?vue&type=style&index=2&id=1298a095&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298a095",
  null
  
)

export default component.exports